import { t } from '@lingui/macro';

import Pencil from '@decisiv/iconix/lib/components/Pencil';

import Flex from '@decisiv/ui-components/lib/components/Flex';
import Button from '@decisiv/ui-components/lib/components/Button';

import type { ManagedDepotsType } from '../..';

interface CellProps {
  rowData: ManagedDepotsType;
}

export default function ActionsCell({ rowData: { webCaseUrl } }: CellProps) {
  return (
    <Flex flex={1} justifyContent="center" alignContent="center">
      <Button
        size="small"
        kind="secondary"
        icon={Pencil}
        text={t`Edit`}
        disabled={!webCaseUrl}
        onClick={() => {
          if (webCaseUrl) {
            window.open(webCaseUrl, '_blank');
          }
        }}
      />
    </Flex>
  );
}
